import React from 'react';
import PropTypes from 'prop-types';
import PopUp from '@/components/Modal/PopUp';
import './style';

class RequestErrors extends React.PureComponent {
  static propTypes = {
    callback: PropTypes.func,
  };

  componentDidMount() {
  }

  replaceStatusName = (keyName, hashTable) => hashTable[keyName];

  handleClick = (e) => {
    e.preventDefault();
    this.props.callback();
  };

  render() {
    return (
      <PopUp>
        <div className="request-errors">
          <div className="request-errors-txt">网络不稳定</div>
          <div className="request-errors-txt">请返回重新加载...</div>
          <div className="request-errors-btn" onClick={this.handleClick}>返 回</div>
        </div>
      </PopUp>
    );
  }
}

export default RequestErrors;
